module.exports = __webpack_public_path__ + "img/centos.77a9658.svg";